export default "data:image/svg+xml,fr-cp.svg"